var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"errors"},_vm._l((_vm.errors),function(error){return _c('div',{key:error,staticClass:"error"},[(error.message)?_c('span',[_vm._v(" "+_vm._s(error.message))]):_c('span',[_vm._v(_vm._s(error.response.data))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }